import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "status",
  class: "flex h-full w-full flex-col items-center justify-center gap-4 p-4 sm:flex-row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 text-notification-error" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 512 512",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" })
  ])
], -1)
const _hoisted_3 = { class: "flex flex-col gap-y-2" }
const _hoisted_4 = { class: "text-4xl font-bold text-notification-error" }
const _hoisted_5 = { class: "flex flex-col gap-y-1" }




export default /*#__PURE__*/_defineComponent({
  __name: 'AppStatus',
  props: {
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})